import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router,RoutesRecognized } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpParams, HttpEventType, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd';
import { environment as configs } from 'src/environments/environment';
import { CommonService } from "./common.service"
import * as CryptoJS from "crypto-js"
// import * as assert from "assert"
//declare var crypto;
import { filter, pairwise } from 'rxjs/operators';
declare var Swal;

@Injectable()
export class IsAuthenticatedGuard implements CanActivate {
  private that = this;
  host = configs['ApiHost'];
  constructor(private httpClient: HttpClient, private rt: Router, private modalService: NzModalService, private CSF: CommonService ) {

  }

  warning = () => {
    Swal.fire({
                type: 'warning',
                title: 'Access Denied',
                text: 'You don\'t have permission to asscess this page'

            })
  }

  async  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    var resp: any = { isLoggedin: false };
    let url = state.url;
    let segmentUrl = url.split('/');
    var algorithm = 'aes256';
    var key = 'password123456.';
    var routeData=next.data;
  var isNavigated;
    var isNewTab=false;
   let pu=sessionStorage.getItem('PUTR');
   let nu=sessionStorage.getItem('NUTR');
    //console.log(pu,"==================UTR")
    //console.log(nu,"==================nUTR")

    if(this.rt.url!='/'){
      let m=(Math.random()*100).toString()
      let mh=CryptoJS.HmacSHA1(m, key)
      sessionStorage.setItem('_FTL',mh);
      let a=next.url
      //console.log(a)
    }
    isNavigated=(pu!=nu);
    let isFirst= sessionStorage.getItem('isFirst')
    if(isFirst=='true'){
      isNewTab=true;
    }
   
   //console.log(isNewTab,isNavigated,this.rt.url,"==================nUTRsdfsdf")
    
    if(this.rt.url=='/' && isNavigated==true ){
      resp['isLoggedin'] = false;
      localStorage.removeItem('user');
      localStorage.removeItem('auth-token');
      localStorage.removeItem('AuthToken');
      localStorage.removeItem('sid');
     sessionStorage.removeItem('PUTR');
     sessionStorage.removeItem('NUTR');
     sessionStorage.removeItem('isFirst')
      window.location.href=configs['logoutLink'];
      //this.rt.navigate(['/login'])
    }

    if(this.rt.url=='/'  && isNewTab==true ){
      resp['isLoggedin'] = false;
      localStorage.removeItem('user');
      localStorage.removeItem('auth-token');
      localStorage.removeItem('AuthToken');
      localStorage.removeItem('sid');
     sessionStorage.removeItem('PUTR');
     sessionStorage.removeItem('NUTR');
     sessionStorage.removeItem('isFirst')
      window.location.href=configs['logoutLink'];
    }



    //console.log(document.referrer,"============== referrer")
      this.CSF.toggleBusy()
      resp = await this.httpClient.get(this.host + '/isloggedin', { headers: new HttpHeaders({ 'Access-Control-Allow-Credentials': 'true' }), withCredentials: true }).toPromise()
      this.CSF.toggleBusy()
      if (resp['isLoggedin'] !== true) {
        localStorage.removeItem('user');
        localStorage.removeItem('auth-token');
        localStorage.removeItem('AuthToken');
        localStorage.removeItem('sid');
     sessionStorage.removeItem('PUTR');
     sessionStorage.removeItem('NUTR');
     sessionStorage.removeItem('isFirst')
      window.location.href=configs['logoutLink'];
      } else {
       
        let userInfo = JSON.parse(localStorage.getItem('user'));
        let userRole = (userInfo.role != undefined && userInfo.role != "") ? userInfo.role.toString() : 'null';
        let userRoleEL = (userInfo.ELRole != undefined && userInfo.ELRole != "") ? userInfo.ELRole.toString()  : 'null';
       
        if (routeData.ROLES.indexOf(userRole) > -1 || routeData.ROLES.indexOf(userRoleEL) > -1) {
          resp['isLoggedin'] = true;
        } else {
          this.warning()
          resp['isLoggedin'] = false;
        }
      }

    






    return resp['isLoggedin'];

  }


}
